import { useContext } from 'react';
import { CausesCondictionsChartsDataContext } from '../contexts/CausesCondictionsChartsDataContext';

export const useCausesCondictionsChartsDataContext = () => {
    return useContext(CausesCondictionsChartsDataContext);
};
